import { render } from "./np-notice.vue?vue&type=template&id=6dbd37bf"
import script from "./np-notice.vue?vue&type=script&lang=js"
export * from "./np-notice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__